<script lang="ts">
  import { debounce, map } from 'lodash-es'
  import { getContext } from 'svelte'
  import { icon } from '#app/lib/icons'
  import { getActionKey } from '#app/lib/key_events'
  import { onChange } from '#app/lib/svelte/svelte'
  import { treq } from '#app/lib/treq'
  import type { TextFilterUris } from '#app/types/entity'
  import Spinner from '#components/spinner.svelte'
  import type { EntitiesSearchResponse } from '#server/controllers/search/lib/entities_search'
  import { getCurrentLang, I18n, i18n } from '#user/lib/i18n'

  let {
    textFilterUris = $bindable(),
  }: {
    textFilterUris: TextFilterUris
  } = $props()

  const searchFilterClaim = getContext('search-filter-claim')
  const searchFilterTypes = getContext('search-filter-types')
  const canSearch = searchFilterClaim && searchFilterTypes

  let textFilter: string = $state()
  let waiting: Promise<EntitiesSearchResponse> = $state()

  async function search () {
    if (textFilter == null || textFilter.trim().length === 0) {
      textFilterUris = null
      return
    }
    waiting = treq('search', 'get', 'default', {
      types: searchFilterTypes,
      lang: getCurrentLang(),
      claim: searchFilterClaim,
      search: textFilter,
      limit: 100,
    }) as Promise<EntitiesSearchResponse>
    const { results } = await waiting
    textFilterUris = map(results, 'uri')
  }

  const lazySearch = debounce(search, 200)

  $effect(() => {
    onChange(textFilter, lazySearch)
  })

  const reset = () => textFilter = ''

  function onKeyDown (e) {
    const key = getActionKey(e)
    if (key === 'esc') reset()
  }
</script>

{#if canSearch}
  <div class="sub-entities-browser-text-filter">
    <input
      type="text"
      placeholder={i18n('Filter…')}
      bind:value={textFilter}
      onkeydown={onKeyDown}
    />
    <div class="search-icon">
      {#await waiting}
        <Spinner />
      {:then}
        {#if textFilter}
          <button
            title={I18n('reset filter')}
            onclick={reset}
          >
            {@html icon('close')}
          </button>
        {:else}
          {@html icon('search')}
        {/if}
      {/await}
    </div>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .sub-entities-browser-text-filter{
    align-self: flex-end;
    position: relative;
  }
  .search-icon{
    position: absolute;
    inset-block: 0;
    inset-inline-end: 0.2em;
    @include display-flex(column, stretch, center);
    color: $grey;
    button{
      padding: 0.2em 0 0.2em 0.2em;
      margin: 0;
      @include shy;
    }
  }
  input{
    margin: 0;
    padding: 0 0.5em;
    block-size: 2.1rem;
    @include radius(2px);
  }
  /* Large screens */
  @media screen and (width >= $small-screen){
    .sub-entities-browser-text-filter{
      margin-inline-end: 1em;
    }
  }
</style>
